document.addEventListener('DOMContentLoaded', function() {
      // Funkcja do płynnego przewijania do elementu
      function smoothScrollTo(target) {
        const element = document.querySelector(target);
        if (element) {
          window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth' // Płynne przewijanie
          });
        }
      }

      // Funkcja do obsługi kliknięć w linki z #
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
          e.preventDefault(); // Zapobiega domyślnemu działaniu (skok do elementu)
          const target = this.getAttribute('href');
          smoothScrollTo(target); // Płynne przewijanie do elementu
        });
      });

      // Funkcja, aby przewijać do sekcji po załadowaniu strony z fragmentem w URL
      if (window.location.hash) {
        smoothScrollTo(window.location.hash);
      }
    });


// Funkcja dodająca klasę 'active' po kliknięciu w przycisk
function toggleActiveOnClick() {
  // Sprawdź, czy obecna strona jest stroną kolekcji
  if (!window.location.pathname.includes('/collections/')) {
    return;
  }

  // Znajdź elementy przycisków
  const filterButton = document.querySelector('[data-toggle-menu="refine-filter"]');
  const sortButton = document.querySelector('[data-toggle-menu="sort-filter"]');
  const filterButtonmob = document.querySelector('.navigation--mobile-button');

  // Znajdź element drawer z aria-expanded wewnątrz drawer--root
  const drawerInstance = document.querySelector('.drawer--root .drawer--instance[data-side="right"][aria-expanded]');

  // Sprawdź, czy drawerInstance został poprawnie znaleziony
  if (!drawerInstance) {
    return;
  }

  // Funkcja dodająca klasę 'active' po kliknięciu
  function addActiveClass(event) {
    // Usuń klasę 'active' ze wszystkich
    filterButton.classList.remove('active');
    sortButton.classList.remove('active');
    filterButtonmob.classList.remove('active');

    // Dodaj klasę 'active' do klikniętego elementu
    event.currentTarget.classList.add('active');
  }

  // Nasłuchuj kliknięcia na przycisk 'Filter'
  filterButton.addEventListener('click', addActiveClass);

  // Nasłuchuj kliknięcia na przycisk 'Sort by'
  sortButton.addEventListener('click', addActiveClass);

  // Nasłuchuj kliknięcia na przycisk 'Filter Mobile'
  filterButtonmob.addEventListener('click', addActiveClass);

  // Funkcja usuwająca klasę 'active' gdy aria-expanded zmienia się na 'false'
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'aria-expanded') {
        const expanded = drawerInstance.getAttribute('aria-expanded') === 'true';

        if (!expanded) {
          // Usuń klasę 'active' z przycisków
          filterButton.classList.remove('active');
          sortButton.classList.remove('active');
          filterButtonmob.classList.remove('active');
        }
      }
    });
  });

  // Obserwuj zmiany atrybutów na elemencie drawerInstance
  observer.observe(drawerInstance, { attributes: true });
}




document.addEventListener('DOMContentLoaded', function() {
  // Sprawdź, czy obecna strona jest stroną kolekcji
  if (!window.location.pathname.includes('/collections/')) {
    return;
  }

  toggleActiveOnClick();

  if ('requestIdleCallback' in window) {
    requestIdleCallback(function() {
      activateSwipeListener();
    });
  } else {
    // Fallback dla przeglądarek, które nie obsługują requestIdleCallback
    setTimeout(activateSwipeListener, 1000);
  }

  function activateSwipeListener() {
    var menu = document.querySelector(".sidebar-menu");
    var leftArrow = document.querySelector(".left-arrow");
    var rightArrow = document.querySelector(".right-arrow");

    // Sprawdzenie, czy elementy istnieją
    if (!menu || !leftArrow || !rightArrow) {
      return;
    }

    var listItemWidth = menu.querySelector("li").offsetWidth + 10; // Szerokość elementu + margines

    function canScrollLeft() {
      return menu.scrollLeft > 0;
    }

    function canScrollRight() {
      var maxScrollLeft = menu.scrollWidth - menu.clientWidth;
      return menu.scrollLeft < maxScrollLeft;
    }

    if (window.innerWidth <= 768) {
      const swipeListener = new SwipeListener(menu, {
        minHorizontal: 30,
        lockAxis: true,
        touch: true,
        mouse: false
      });

      // Nasłuch na event swipe
      menu.addEventListener("swipe", function(e) {
        const directions = e.detail.directions;

        if (directions.left && canScrollRight()) {
          menu.scrollBy({ left: listItemWidth, behavior: 'smooth' });
        } else if (directions.right && canScrollLeft()) {
          menu.scrollBy({ left: -listItemWidth, behavior: 'smooth' });
        }
      });

      // Obsługa kliknięcia w prawą strzałkę
      rightArrow.addEventListener('click', function() {
        if (canScrollRight()) {
          menu.scrollBy({ left: listItemWidth, behavior: 'smooth' });
        }
      });

      // Obsługa kliknięcia w lewą strzałkę
      leftArrow.addEventListener('click', function() {
        if (canScrollLeft()) {
          menu.scrollBy({ left: -listItemWidth, behavior: 'smooth' });
        }
      });
    }
  }

  window.addEventListener('resize', activateSwipeListener);
});




document.addEventListener('DOMContentLoaded', function() {
  function applyProductBorders() {
    // 1. Pobieramy wszystkie bloki wewnątrz formularza produktu
    const allBlocks = document.querySelectorAll('.product-page--form .product-page--block');
    const prMetaBlocks = document.querySelectorAll('.product-page--block[data-block-type="pr-meta-details"]');
    const careBlock = document.querySelector('.product-page--block[data-block-type="care"]');
    
    // 2. Logika dla pr-meta-details (Marginesy)
    if (prMetaBlocks.length >= 2) prMetaBlocks[1].style.marginTop = '0px';
    if (prMetaBlocks.length >= 3) {
      prMetaBlocks[2].style.marginTop = '0px';
      const p = prMetaBlocks[2].querySelector('p');
      if (!p || p.textContent.trim() === '') {
        prMetaBlocks[2].style.display = 'none';
      }
    }

    // 3. Logika dla Care (Ukrywanie jeśli naprawdę pusty)
    if (careBlock) {
      // Szukamy tekstu wewnątrz akordeonu
      const hasRealContent = careBlock.querySelector('.benefit-block-meta') || careBlock.querySelector('.editor-main-description');
      const textContent = careBlock.innerText.trim();
      
      if (!hasRealContent || textContent === "" || textContent === "Care") {
        careBlock.style.display = 'none';
      }
    }

    // 4. RESETOWANIE BORDERÓW (Ważne!)
    // Czyścimy bordery tylko z sekcji, którymi chcemy zarządzać
    const sectionsToManage = ['description', 'pr-meta-details', 'care'];
    
    let lastVisibleInfoBlock = null;

    allBlocks.forEach(block => {
      const type = block.getAttribute('data-block-type');
      
      // Resetujemy border jeśli to jedna z naszych sekcji
      if (sectionsToManage.includes(type)) {
        block.style.setProperty('border-bottom', 'none', 'important');
      }

      // Sprawdzamy czy to ostatni widoczny blok z naszych wybranych typów
      if (sectionsToManage.includes(type) && window.getComputedStyle(block).display !== 'none') {
        lastVisibleInfoBlock = block;
      }
    });

    // 5. NARYSOWANIE LINII
    // Jeśli po naszych sekcjach jest coś jeszcze (np. pickup), rysujemy linię pod ostatnią sekcją info
    if (lastVisibleInfoBlock) {
      lastVisibleInfoBlock.style.setProperty('border-bottom', '1px solid var(--bdr-dark--general)', 'important');
    }
  }

  // Uruchomienie
  applyProductBorders();
  // Drugie wywołanie dla pewności (Shopify dynamic content)
  setTimeout(applyProductBorders, 600);
});




// Sprawdź, czy body ma klasę 'template--product'
  if (document.body.classList.contains('template--product')) {
    // Twój kod JavaScript uruchomi się tylko na stronach produktowych

    // Po załadowaniu strony ustaw domyślnie pierwszą sekcję jako aktywną
    document.addEventListener('DOMContentLoaded', function() {
      const firstCollapsible = document.querySelector('.collapsible-row--root');
      if (firstCollapsible) {
        firstCollapsible.classList.add('active');
        const toggleButton = firstCollapsible.querySelector('.collapsible-row--toggle');
        const contentWrapper = firstCollapsible.querySelector('.collapsible-row--content-wrapper');
        const content = contentWrapper.querySelector('.collapsible-row--content');

        toggleButton.setAttribute('aria-expanded', 'true');
        contentWrapper.setAttribute('data-transition-active', 'true');
        contentWrapper.style.height = content.scrollHeight + 'px';
      }
    });

    document.querySelectorAll('.collapsible-row--toggle').forEach(button => {
      button.addEventListener('click', function(event) {
        const currentCollapsibleRoot = button.closest('.collapsible-row--root');
        const isActive = currentCollapsibleRoot.classList.contains('active');

        if (isActive) {
          // Usuń klasę 'active' i złóż sekcję
          currentCollapsibleRoot.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
          const contentWrapper = currentCollapsibleRoot.querySelector('.collapsible-row--content-wrapper');
          contentWrapper.setAttribute('data-transition-active', 'false');
          contentWrapper.style.height = '0px';
        } else {
          // Usuń klasę 'active' z innych sekcji i złóż je
          document.querySelectorAll('.collapsible-row--root.active').forEach(root => {
            root.classList.remove('active');
            const toggleButton = root.querySelector('.collapsible-row--toggle');
            toggleButton.setAttribute('aria-expanded', 'false');
            const contentWrapper = root.querySelector('.collapsible-row--content-wrapper');
            contentWrapper.setAttribute('data-transition-active', 'false');
            contentWrapper.style.height = '0px';
          });

          // Dodaj klasę 'active' do klikniętej sekcji i rozwiń ją
          currentCollapsibleRoot.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
          const contentWrapper = currentCollapsibleRoot.querySelector('.collapsible-row--content-wrapper');
          const content = contentWrapper.querySelector('.collapsible-row--content');
          contentWrapper.setAttribute('data-transition-active', 'true');
          contentWrapper.style.height = content.scrollHeight + 'px';
        }
      });
    });
  }


document.addEventListener('DOMContentLoaded', function() {
  // Sprawdź, czy obecna strona jest stroną kolekcji
  if (!window.location.pathname.includes('/collections/')) {
    return;
  }

  // Nasłuchuj kliknięcia na przycisk "Sortuj według"
  const sortButton = document.querySelector('.navigation--button[data-toggle-menu="sort-filter"]');
  
  if (sortButton) {
    sortButton.addEventListener('click', function() {
      const filterCategories = document.querySelectorAll('.filter--form .filter--category');

      if (filterCategories.length >= 4) {
        filterCategories[1].style.display = 'none';
        filterCategories[2].style.display = 'none';
        filterCategories[3].style.display = 'none';
        filterCategories[4].style.display = 'none';
        filterCategories[5].style.display = 'none';
        filterCategories[6].style.display = 'none';
      }
    });
  }

  // Nasłuchuj kliknięcia na przycisk "Filtr"
  const filterButton = document.querySelector('.navigation--button[data-toggle-menu="refine-filter"]');
  
  if (filterButton) {
    filterButton.addEventListener('click', function() {
      const filterCategories = document.querySelectorAll('.filter--form .filter--category');
      
      filterCategories.forEach(function(category, index) {
        if (index === 0) {
          category.style.display = 'none';
        } else {
          category.style.display = 'block';
        }
      });
    });
  }
});


  // document.addEventListener('DOMContentLoaded', function() {
    //const keywords = ['Panna', 'Bliźnięta', 'Słońce'];
    //const container = document.querySelector('.collapsible-row--content');

    //if (container) {
      //keywords.forEach(function(keyword) {
        //const regex = new RegExp(`(${keyword})`, 'g');
        //container.innerHTML = container.innerHTML.replace(regex, `<a href="/search?q=${keyword}">$1</a>`);
      //});
   // }
  //});

document.addEventListener("DOMContentLoaded", function () {
    const alphabetList = document.querySelector(".alphabet-list"); // Alphabet list container
    const parentMenu = document.querySelector(".menu-ul-img ul"); // Container for the links
    const links = Array.from(parentMenu.querySelectorAll(".x-menu--level-3--link")); // Links to sort
    const imageContainer = document.querySelector(".x-menu--level-3--image-container");
    const imageElement = document.querySelector(".x-menu--level-3--image");

    // Default image for Agate
    const defaultImageUrl = "https://cdn.shopify.com/s/files/1/0737/0106/4968/files/68104b5adfff80.71819459.png?v=1747482573";

    // Display the default image for Agate on load
    imageElement.src = defaultImageUrl;
    imageContainer.style.display = "flex";

    // Map of alphabets for each language
    const alphabets = {
        en: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        pl: "ABCDEFGHIJKLŁMNOPQRSTUVWXYZŻ",
        uk: "АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯ",
        de: "ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜß",
        fr: "ABCDEFGHIJKLMNOPQRSTUVWXYZÀÂÇÉÈÊËÎÏÔÙÛÜŸ",
        es: "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
        it: "ABCDEFGHIJKLMNOPQRSTUVWXYZÀÈÉÌÍÎÒÓÙÚ",
        nl: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        sv: "ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖ",
        da: "ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ",
        fi: "ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖ",
        cs: "AÁBCČDĎEÉĚFGHIÍJKLMNŇOÓPQRŘSŠTŤUÚŮVWXYÝZŽ",
        hr: "AŠBCČĆDĐEFGHIJKLMNOPRSŠTUVZŽ",
        el: "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ",
        hu: "AÁBCDEÉFGHIÍJKLMNOÓÖŐPRSTUÚÜŰVWXYZ",
        bg: "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЮЯ",
        no: "ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ",
        pt: "ABCDEFGHIJKLMNOPQRSTUVWXYZÁÀÂÃÉÊÍÓÔÕÚÜ",
        ro: "AĂÂBCDEFGHIÎJKLMNOPQRSTUVWXZ",
        ru: "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ",
        sl: "AČDEFGHIJKLMNOPRSŠTUVZŽ",
    };

    // Helper: Get current language from the <html> tag
    function getCurrentLanguage() {
        const htmlElement = document.documentElement; // Get <html> element
        return htmlElement.getAttribute("lang") || "en"; // Default to English if no lang attribute
    }

    // Helper: Get alphabet for the current language
    function getAlphabetForLanguage(language) {
        return alphabets[language] || alphabets["en"]; // Default to English if language not found
    }

    // Step 1: Update the alphabet list dynamically
    function updateAlphabetList(language) {
        const alphabet = getAlphabetForLanguage(language);
        alphabetList.innerHTML = ""; // Clear the current alphabet

        alphabet.split("").forEach(letter => {
            const listItem = document.createElement("li");
            listItem.className = "alphabet-item";
            listItem.setAttribute("data-letter", letter);

            const anchor = document.createElement("a");
            anchor.href = "#";
            anchor.textContent = letter;

            listItem.appendChild(anchor);
            alphabetList.appendChild(listItem);
        });

        // Attach hover events to the new alphabet items
        attachAlphabetHoverEvents();
    }

    // Step 2: Sort links by language
    function sortLinksByLanguage(language) {
        return links.slice().sort((a, b) => {
            const textA = a.textContent.trim();
            const textB = b.textContent.trim();
            return textA.localeCompare(textB, language); // Sort using locale
        });
    }

    // Step 3: Group links by first letter
    function groupLinksByAlphabet(sortedLinks, alphabet) {
        const grouped = {};
        alphabet.split("").forEach(letter => {
            grouped[letter] = [];
        });

        sortedLinks.forEach(link => {
            const firstLetter = link.getAttribute("data-first-letter")?.toUpperCase() || "";
            if (grouped[firstLetter]) {
                grouped[firstLetter].push(link);
            }
        });

        return grouped;
    }

    // Step 4: Display links dynamically
    function displayLinks(selectedLetter, groupedLinks, alphabet) {
        parentMenu.innerHTML = ""; // Clear the menu

        let displayedLinks = [];
        let totalLinks = 0;
        let isFirstLetter = true;

        for (let i = alphabet.indexOf(selectedLetter); i < alphabet.length && totalLinks < 20; i++) {
            const letter = alphabet[i];
            if (!groupedLinks[letter] || groupedLinks[letter].length === 0) {
                continue;
            }

         if (!isFirstLetter) {
    const letterHeading = document.createElement("li"); // Tworzenie elementu <li>
    letterHeading.classList.add("letter-heading"); // Dodanie klasy do <li>

    const letterParagraph = document.createElement("p"); // Tworzenie elementu <p>
    letterParagraph.textContent = letter; // Ustawienie tekstu w <p>

    letterHeading.appendChild(letterParagraph); // Dodanie <p> jako dziecka <li>
    parentMenu.appendChild(letterHeading); // Dodanie <li> do menu
}

            groupedLinks[letter].forEach(link => {
                if (totalLinks < 20) {
                    const clonedLink = link.cloneNode(true);
                    displayedLinks.push(clonedLink);
                    parentMenu.appendChild(clonedLink);
                    totalLinks++;
                }
            });

            isFirstLetter = false;
        }

        attachImageHoverEvents(parentMenu.querySelectorAll(".x-menu--level-3--link"));
    }

    // Step 5: Attach hover events for alphabet
    function attachAlphabetHoverEvents() {
        const alphabetItems = document.querySelectorAll(".alphabet-item");
        alphabetItems.forEach(item => {
            item.addEventListener("mouseenter", function () {
                const selectedLetter = this.getAttribute("data-letter").toUpperCase();
                const currentLanguage = getCurrentLanguage();
                const alphabet = getAlphabetForLanguage(currentLanguage);
                const groupedLinks = groupLinksByAlphabet(sortLinksByLanguage(currentLanguage), alphabet);
              // Highlight the active letter
                alphabetItems.forEach(i => i.classList.remove("active"));
                this.classList.add("active");
                displayLinks(selectedLetter, groupedLinks, alphabet);
            });
        });
    }

    // Step 6: Attach image hover events
    function attachImageHoverEvents(links) {
        links.forEach(link => {
            link.addEventListener("mouseenter", function () {
                const imageUrl = this.getAttribute("data-image");
                if (imageUrl) {
                    imageElement.src = imageUrl;
                    imageContainer.style.display = "flex";
                }
            });

            link.addEventListener("mouseleave", function () {
                imageElement.src = defaultImageUrl; // Reset to default image
            });
        });
    }

    // Step 7: Limit default display to 20 items
    function limitDefaultDisplay(sortedLinksArray) {
        parentMenu.innerHTML = ""; // Clear the menu
        const limitedLinks = sortedLinksArray.slice(0, 20); // Take first 20 links

        limitedLinks.forEach(link => {
            parentMenu.appendChild(link.cloneNode(true));
        });

        attachImageHoverEvents(parentMenu.querySelectorAll(".x-menu--level-3--link"));
    }

    // Initialize the menu
    function initializeMenu() {
        const currentLanguage = getCurrentLanguage();
        const alphabet = getAlphabetForLanguage(currentLanguage);
        const sortedLinksArray = sortLinksByLanguage(currentLanguage);
        const groupedLinks = groupLinksByAlphabet(sortedLinksArray, alphabet);

        updateAlphabetList(currentLanguage); // Update the alphabet dynamically
        limitDefaultDisplay(sortedLinksArray); // Limit the default display to 20 items
        attachAlphabetHoverEvents(); // Attach hover events for the alphabet
    }

    // Initialize on page load
    initializeMenu();
});

document.addEventListener("DOMContentLoaded", function () {
    const secondLevelLinks = document.querySelectorAll(".x-menu--level-2--link");

    secondLevelLinks.forEach(secondLevelLink => {
        // Get the third-level container inside the current second-level link
        const thirdLevelContainer = secondLevelLink.querySelector(".x-menu--level-3--container1");
        const anchor = secondLevelLink.querySelector("a"); // Select the <a> element inside the second-level link

        if (thirdLevelContainer && anchor) {
            // Add event listeners for both second-level and third-level hover
            secondLevelLink.addEventListener("mouseenter", function () {
                anchor.classList.add("active");
            });

            secondLevelLink.addEventListener("mouseleave", function () {
                anchor.classList.remove("active");
            });

            thirdLevelContainer.addEventListener("mouseenter", function () {
                anchor.classList.add("active");
            });

            thirdLevelContainer.addEventListener("mouseleave", function () {
                anchor.classList.remove("active");
            });
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');

  tabButtons.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      // Remove all active classes
      tabButtons.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // Add active to clicked tab
      btn.classList.add('active');
      tabContents[index].classList.add('active');
    });
  });

  // Activate first tab on load
  if (tabButtons.length && tabContents.length) {
    tabButtons[0].classList.add('active');
    tabContents[0].classList.add('active');
  }
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collection-card .play-icon").forEach(icon => {
    icon.addEventListener("click", function (e) {
      const parent = e.target.closest(".collection-card");
      const embedHtml = parent.querySelector(".video-embed-html");

      if (embedHtml) {
        const popupContent = document.getElementById("video-popup-content");
        popupContent.innerHTML = embedHtml.innerHTML;
        document.getElementById("video-popup").style.display = "block";
      }
    });
  });
});

function closeVideoPopup() {
  document.getElementById("video-popup").style.display = "none";
  document.getElementById("video-popup-content").innerHTML = "";
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.simple-carousel').forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const items = Array.from(track.children);
    const prev = carousel.querySelector('.carousel-btn.prev');
    const next = carousel.querySelector('.carousel-btn.next');
    const maxIndex = items.length - 3;
    let index = 0;

    function update() {
      const gap = parseFloat(getComputedStyle(track).gap || 0);
const itemWidth = items[0].getBoundingClientRect().width + gap;
track.style.transform = `translateX(-${index * itemWidth}px)`;

      prev.disabled = index === 0;
      next.disabled = index >= maxIndex;
    }

    prev.addEventListener('click', () => {
      if (index > 0) {
        index--;
        update();
      }
    });

    next.addEventListener('click', () => {
      if (index < maxIndex) {
        index++;
        update();
      }
    });

    window.addEventListener('resize', update);
    update();
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const mq = window.matchMedia("(max-width: 768px)");
  const produkInfo = document.querySelector(".produkt-info");
  const form = document.querySelector(".product-page--form");

  function moveInfo() {
    if (!produkInfo || !form) return;
    if (mq.matches) {
      // na mobilnym - przeniesienie
      form.parentNode.insertBefore(produkInfo, form.nextSibling);
    } else {
      // opcjonalnie: przenieś z powrotem np. do miejsca pierwotnego lub nic
      // np. document.body.appendChild(produkInfo);
    }
  }

  mq.addEventListener("change", moveInfo);
  moveInfo();
});

document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".event-new-template .product-buy-buttons--primary-wrapper");
  const footer  = document.querySelector("footer");
  if (!wrapper || !footer) return;

  let stickPoint, unstickPoint;

  function calcPoints() {
    const wrapperRect = wrapper.getBoundingClientRect();
    const wrapperTop  = wrapperRect.top + window.scrollY;
    const wrapperH    = wrapperRect.height;
    const vpH         = window.innerHeight;

    // moment, w którym wrapper stanie się fixed:
    // gdy dolna krawędź viewportu przewinie się o 50px poniżej dolnej krawędzi wrappera
    stickPoint   = wrapperTop + wrapperH + 50 - vpH;
    // moment, w którym musi wrócić do normalnego (just przed stopką):
    // gdy scrollY osiągnie początek stopki minus viewport
    unstickPoint = footer.getBoundingClientRect().top + window.scrollY - vpH;
  }

  // wywołujemy na starcie i przy resize
  calcPoints();
  window.addEventListener("resize", calcPoints);

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function update() {
    const scrollY = window.scrollY;

    // jeśli jesteśmy pomiędzy punktami, dodaj klasę
    if (scrollY >= stickPoint && scrollY < unstickPoint) {
      wrapper.classList.add("is-fixed");
    } else {
      wrapper.classList.remove("is-fixed");
    }

    ticking = false;
  }

  window.addEventListener("scroll", onScroll);
  update(); // ustaw stan na start
});
